import {mapGetters} from 'vuex';
import { openOverlayer, closeOverlayer } from '../../utilities/nojq/_overlayer.js';

export default {
    name: 'mvtOverlay',
    inject: ['$eventBus'],
    computed:{
        ...mapGetters('glb', ['glb'])
    },
    data() {
        return {
            isActive: false,
            currentName: '',
            currentTrigger: ''
        };
    },
    methods: {
        show() {
            if(!this.isActive){
                this.isActive = true;
                openOverlayer('overlay-active');
            }
            this.$emit('shown');
        },
        hide() {
            if(this.isActive){
                this.isActive = false;
                closeOverlayer('overlay-active');
            }
            this.$emit('hidden');
        }
    },
    mounted() {
        var that = this;
        this.$eventBus.$on('close-overlay', function(){
            that.hide();
        });
    },
    beforeUnmount(){
        this.hide();
        this.$eventBus.$off('close-overlay');
        $('#body').removeClass('overlay-active');
    }
};
